// =============================================================================
// TRENTON THUNDER PLAYER NAME MAPPING SYSTEM
// Single source of truth for all real ↔ mock player name conversions
// =============================================================================

// -----------------------------------------------------------------------------
// REAL → MOCK MAPPINGS (Primary Source of Truth)
// -----------------------------------------------------------------------------

export const REAL_TO_MOCK_PITCHER_MAP = {
  // Pitchers
  'Jude Abbadessa': 'Carlos Alvarez',
  'Miguel Sime': 'Miguel Acosta',
  'Bryson Dudley': 'Alex Blair',
  'Chris Billingsley': 'David Bennett',
  'Clayton Johnson': 'Chris Clark',
  'Joe Ariola': 'Ryan Dean',
  'Tommy Case': 'Josh Doyle',
  'John Carver': 'Trevor Evans',
  'Aidan Weaver': 'Jake Ellis',
  'Andrew Ronne': 'Blake Kane',
  'Brian Young': 'Codi Knight',
  'Caden Spivey': 'Preston Lewis',
  'Codi Scott': 'Jackson Long',
  'Collin Bosley-Smith': 'Drew Marsh',
  'Cooper McGrath': 'Connor Mason',
  'Cullen Horowicz': 'Miles Newman',
  'Eddie Smink': 'Kyle Nicholson',
  'Gavin King': 'Raymond Ortiz',
  'JJ Almeda': 'Caden Pierce',
  'Jarrette Bonet': 'Jayden Parker',
  'Kai Fyke': 'Kevin Ray',
  'Luis Misla': 'Preston Reed',
  'Luke Delongchamp': 'Paulo Salazar',
  'Miles Garrett': 'Xavier Simmons',
  'Nick Frusco': 'Cullen Thomas',
  'Noah Edders': 'Miles Tracy',
  'Paulo Noris': 'Vincent White',
  'Preston Prince': 'Peter Winters',
  'Ryan Calvert': 'Leo West',
  'Sean Finn': 'Jason Young',
  'Zach Silfies': 'Luke Zimmerman'
};

export const REAL_TO_MOCK_HITTER_MAP = {
  'Rowan Masse': 'Jake Allen',
  'Michael Whooley': 'Tyler Armstrong',
  'Cole Leach': 'Alex Bell',
  'Taylor Belza': 'Michael Butler',
  'Evin Sullivan': 'David Campbell',
  'Aaron Graeber': 'Carlos Cooper',
  'Carsten Sabathia III': 'Ryan Dawson',
  'Jakob Poturnak': 'Josh Dixon',
  'John Schroeder': 'Matt Edwards',
  'JuJu Stevens': 'Tony Escobar',
  'Jaden Sheffield': 'Steve Fisher',
  'Aaron Whitley': 'Nick Fox',
  'Justin Fogel': 'Brad Gibson',
  'Logan Dawson': 'Dan Gonzales',
  'Harry Genth': 'Joe Gomes',
  'Jayden Melendez': 'Chris Hall',
  'Paulo Noris': 'Sam Harrison',
  'Brayden Fraasman': 'Kevin Jones',
  'Danny Corona': 'Luis Jimenez'
};

// -----------------------------------------------------------------------------
// AUTO-GENERATED ARRAYS & REVERSE MAPPINGS (Don't Edit These)
// -----------------------------------------------------------------------------

// Mock name arrays (auto-generated from mappings above)
export const MOCK_PITCHER_NAMES = [...new Set(Object.values(REAL_TO_MOCK_PITCHER_MAP))];
export const MOCK_HITTER_NAMES = [...new Set(Object.values(REAL_TO_MOCK_HITTER_MAP))];

// Reverse mappings (auto-generated)
export const MOCK_TO_REAL_PITCHER_MAPPING = Object.fromEntries(
  Object.entries(REAL_TO_MOCK_PITCHER_MAP).map(([real, mock]) => [mock, real])
);

export const MOCK_TO_REAL_HITTER_MAPPING = Object.fromEntries(
  Object.entries(REAL_TO_MOCK_HITTER_MAP).map(([real, mock]) => [mock, real])
);

// -----------------------------------------------------------------------------
// UTILITY FUNCTIONS
// -----------------------------------------------------------------------------

// Get mock names from real names
export const getMockPitcherName = (realName) => REAL_TO_MOCK_PITCHER_MAP[realName] || realName;
export const getMockHitterName = (realName) => REAL_TO_MOCK_HITTER_MAP[realName] || realName;

// Get real names from mock names
export const getRealPitcherName = (mockName) => MOCK_TO_REAL_PITCHER_MAPPING[mockName] || mockName;
export const getRealHitterName = (mockName) => MOCK_TO_REAL_HITTER_MAPPING[mockName] || mockName;

// Get all names
export const getAllMockPitchers = () => MOCK_PITCHER_NAMES;
export const getAllMockHitters = () => MOCK_HITTER_NAMES;
export const getAllRealPitchers = () => Object.keys(REAL_TO_MOCK_PITCHER_MAP);
export const getAllRealHitters = () => Object.keys(REAL_TO_MOCK_HITTER_MAP);

// Abbreviations
export const getPitcherAbbreviation = (realName) => {
  const abbreviations = {
    'Test Pitcher': 'C.Aco',
    'Jude Abbadessa': 'J.Abb',
    'Joe Ariola': 'R.Dea',
    'Tommy Case': 'J.Doy',
    'John Carver': 'T.Eva',
    'Miguel Sime': 'M.Sim',
    'Bryson Dudley': 'B.Dud',
    'Chris Billingsley': 'C.Bil',
    'Clayton Johnson': 'C.Joh',
    'Joe Ariola': 'J.Ari',
    'Tommy Case': 'T.Cas',
    'John Carver': 'J.Car',
    'Aidan Weaver': 'A.Wea',
    'Andrew Ronne': 'A.Ron',
    'Brian Young': 'B.You',
    'Caden Spivey': 'C.Spi',
    'Codi Scott': 'C.Sco',
    'Collin Bosley-Smith': 'C.Bos',
    'Cooper McGrath': 'C.McG',
    'Cullen Horowicz': 'C.Hor',
    'Eddie Smink': 'E.Smi',
    'Gavin King': 'G.Kin',
    'JJ Almeda': 'J.Alm',
    'Jarrette Bonet': 'J.Bon',
    'Kai Fyke': 'K.Fyk',
    'Luis Misla': 'L.Mis',
    'Luke Delongchamp': 'L.Del',
    'Miles Garrett': 'M.Gar',
    'Nick Frusco': 'N.Fru',
    'Noah Edders': 'N.Edd',
    'Paulo Noris': 'P.Nor',
    'Preston Prince': 'P.Pri',
    'Ryan Calvert': 'R.Cal',
    'Sean Finn': 'S.Fin',
    'Zach Silfies': 'Z.Sil'
  };
  return abbreviations[realName] || realName.substring(0, 4);
};

export const getMockPitcherAbbreviation = (mockName) => {
  const parts = mockName.split(' ');
  if (parts.length >= 2) {
    return parts[0][0] + parts[1].substring(0, 3);
  }
  return mockName.substring(0, 4);
};
